import { render, staticRenderFns } from "./student-list.vue?vue&type=template&id=02b143fb&scoped=true"
import script from "./student-list.vue?vue&type=script&lang=js"
export * from "./student-list.vue?vue&type=script&lang=js"
import style0 from "./student-list.vue?vue&type=style&index=0&id=02b143fb&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b143fb",
  null
  
)

export default component.exports